// WAFによるブロック(メンテナンス/アクセス制限)を検知したときに投げるエラー。
// 検知時点で alert 表示とリロードを行うため、呼び出し側ではトースト等の
// 追加のエラー表示を行わない。
export class WafBlockError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "WafBlockError";
  }
}

export function isWafBlockError(err: unknown): err is WafBlockError {
  return err instanceof WafBlockError;
}
